<template>
    <section class="wrapper">
        <header-component/>
        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Main content -->
            <section class='content-data'>

                <slot/>

                <div class="info">
                    Более подробно о сопровождении людей с РАС в Нижегородской области можно узнать по ссылке ниже 
                    <a href="https://csr.nobl.ru/activity/13095/" target="_blank">https://csr.nobl.ru/activity/13095/</a>.
                </div>

                <div class="info" v-if="$store.state.auth?.oidc?.user">
                    Скачать мобильное приложение пациента вы можете по ссылке ниже
                    <a href="https://www.rustore.ru/catalog/app/com.RasMobilePerson" target="_blank">https://www.rustore.ru/catalog/app/com.RasMobilePerson</a>.
                </div>

                <div class="info">
                    <a href="https://vk.com/csrno" target="_blank" class="text-decoration-none">
                        <button-component class="btn-sm news-btn">
                            <icon-component name="news-icon"/>
                            <span>Новости</span>
                        </button-component>
                    </a>
                </div>
            </section>
            <!-- /.content -->
        </div>
        <!-- /.content-wrapper -->


    </section>
</template>

<script>
// import Header from "@/common/components/Header.vue";
// import Sidebar from "@/common/components/Sidebar.vue";
// import Footer from "@/common/components/Footer.vue";

import HeaderComponent from "../common/components/HeaderComponent";
import IconComponent from "@/common/ui/IconComponent";
import ButtonComponent from "@/common/components/ButtonComponent";

export default {
    name: "DefaultLayout",
    components: {
        HeaderComponent,
        IconComponent,
        ButtonComponent,
        // Header,
        // Sidebar,
        // Footer,
    },


};
</script>

<style scoped lang='scss'>

.content-wrapper {
    max-width: 1320px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    padding: 0 20px;

    .content-data {
        width: 100%
    }

    .info {
        margin-top: 20px;
        /*padding: 10px 0;*/
    }
    
    .news-btn {
        display: flex;
        align-items: center;

        span {
            padding-left: 5px;
        }
    }
}
</style>